import cn from 'clsx';
import styles from './styles.module.css';
import {useTranslation} from 'react-i18next';

type PriceBadgeProps = {
  price: string;
  originalPrice?: string;
  discountPercentage?: number;
  className?: string;
};

export const PriceBadge = ({
  price,
  originalPrice,
  discountPercentage,
  className,
}: PriceBadgeProps) => {
  const {t} = useTranslation('enhance_your_stay');
  const hasDiscount = !!discountPercentage && !!originalPrice;

  return (
    <div className={cn(styles.container, className)}>
      {hasDiscount && (
        <div className={styles.discountBadge}>
          {t('discount_off', {percentage: discountPercentage})}
        </div>
      )}
      <div className={styles.priceBadge}>
        {hasDiscount && <span className={styles.originalPrice}>{originalPrice}</span>}
        <span className={cn(styles.currentPrice, hasDiscount && styles.discounted)}>
          {price}
        </span>
      </div>
    </div>
  );
};
